import type { ServicePageData } from '../../../mocks/servicePages';

interface ServiceHeroProps {
  service: ServicePageData;
}

export default function ServiceHero({ service }: ServiceHeroProps) {
  return (
    <section className="relative min-h-[500px] lg:min-h-[560px] flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src={service.heroImageUrl}
          alt={service.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#0f1f3d]/90 to-[#0a1628]/85"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Breadcrumb */}
        <nav className="mb-4 text-sm" aria-label="Breadcrumb">
          <ol className="flex items-center gap-2 text-gray-400">
            <li>
              <a href="/" className="hover:text-cyan-400 transition-colors">Home</a>
            </li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li className="text-cyan-300 truncate max-w-xs">{service.title.split(' in Las Vegas')[0]}</li>
          </ol>
        </nav>

        {/* Emergency Badge */}
        <div className="inline-block bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-5 animate-pulse">
          ⚡ SAME-DAY SERVICE — LAS VEGAS &amp; CLARK COUNTY
        </div>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight max-w-3xl">
          {service.title}
        </h1>
        <p className="text-lg sm:text-xl text-cyan-300 font-semibold mb-6 max-w-2xl">
          {service.tagline}
        </p>

        {/* Trust Pills */}
        <div className="flex flex-wrap gap-3 mb-8">
          {['Licensed & Insured', 'Flat-Rate Pricing', 'Same-Day Service', 'No Hidden Fees'].map((t) => (
            <span key={t} className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm px-3 py-1.5 rounded-full font-medium">
              <i className="ri-check-line text-cyan-400 text-base"></i>
              {t}
            </span>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="tel:7252675482"
            className="flex items-center justify-center gap-2 bg-red-600 text-white px-8 py-5 rounded-lg font-black text-lg hover:bg-red-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call Now — (725) 267-5482
          </a>
          <a
            href="#estimate"
            className="flex items-center justify-center gap-2 bg-white text-[#0f1f3d] px-8 py-5 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </a>
        </div>
        <p className="mt-4 text-sm text-gray-400 italic">No-obligation estimate • Immediate service available • Licensed &amp; Insured in Nevada</p>
      </div>
    </section>
  );
}
